export const USERDATAFIRM_DELETE_RESET = 'USERDATAFIRM_DELETE_RESET'
export const USERDATAFIRM_DELETE_SET_ERROR = 'USERDATAFIRM_DELETE_SET_ERROR'
export const USERDATAFIRM_DELETE_SET_DELETED = 'USERDATAFIRM_DELETE_SET_DELETED'
export const USERDATAFIRM_DELETE_TOGGLE_LOADING = 'USERDATAFIRM_DELETE_TOGGLE_LOADING'
